import React from "react";
import TestCasePriority from "./TestCasePriority";
import TestRunStatus from "./TestRunStatus";
import { Tooltip, Icon } from "antd";
import UserAvatar from "react-user-avatar";
import {
  tcFieldHelper,
  getLocalFromNow,
  getLocalDate
} from "../../utils/common";
import TestCaseTags from "../TestCase/elements/TestCaseTags";
import TCUserAvatar from "./TCUserAvatar";
//const { Link } = Anchor;

const priorities = {
  "0": { label: "Low Priority", color: "#444" },
  "1": { label: "Normal Priority", color: "#6bd222" },
  "2": { label: "High Priority", color: "#D2222D" }
};

export default {
  getColumns: cb => {
    if (!cb) {
      let cb = {
        onSuiteClick: () => {}
      };
    }
    return [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        filter: {
          type: "numeric",
          filterOptions: { operator: "equal" }
        },
        sorter: true,
        //filterType: "numeric"
        //fixed: "left",
        width: 50
      },
      {
        title: "Title",
        dataIndex: "title",
        filter: {
          type: "text",
          filterOptions: { operator: "contains" }
        },
        sorter: true,
        width: "30%"

        //fixed: "left",
      },
      {
        title: "Suite",
        dataIndex: "suite",
        filter: {
          type: "suite",
          filterOptions: { operator: "contains" }
        },
        render: (text, testCase) => (
          <span>
            <Tooltip
              onVisibleChange={cb.onVisibleChange}
              placement="top"
              title={
                testCase.suite != null ? (
                  <a
                    onClick={e => cb.onSuiteClick(e, testCase)}
                    style={{ textDecoration: "underline", color: "white" }}
                  >
                    {testCase.suite.title}
                  </a>
                ) : (
                  ""
                )
              }
            >
              <span
                style={{
                  textDecoration: "underline dotted",
                  color: "inherit",
                  textDecorationColor: "#cac9c9",
                  zIndex: 20
                }}
              >
                {testCase.suite.title != undefined
                  ? testCase.suite.title
                  : text}
              </span>
            </Tooltip>
          </span>
        ),
        sorter: true
        //width: 100
      },
      {
        title: "Priority",
        dataIndex: "priority",
        //width: 100,
        // onHeaderCell: col => {
        //   console.log('COL', col);
        // },
        render: text => <TestCasePriority priority={text} />,
        filter: {
          type: "priority",
          filterOptions: { options: ["Low", "Normal", "High"] }
        },
        sorter: true
        //filterType: "option"
      },
      {
        title: "Last Run Status",
        dataIndex: "last_run_status",
        //width: 100,
        render: status => <TestRunStatus status={status} />,

        filter: {
          type: "option",
          filterOptions: { options: ["Failed", "Passed", "Skipped"] }
        },
        className: "alignCenter"
        //[{text: <TestRunStatus status="fail" />, value: "fail"}, {text: <TestRunStatus status={1} />, value: 1}, {text: <TestRunStatus status={2} />, value: 2}],
      },
      {
        title: "Last Run",
        dataIndex: "last_run_on",
        //width: 100,
        render: last_run_on => tcFieldHelper.lastRanOn(last_run_on),
        filter: {
          type: "date",
          className: "alignCenter"
          //filterOptions: { options: ["Low", "Medium", "High"] }
        }
      },
      {
        title: "Runs",
        dataIndex: "run_count",
        filter: {
          type: "numeric"
        },
        className: "alignCenter"
      },

      {
        title: "Created",
        dataIndex: "createdAt",
        filterName: "created_at",
        //width: 100,
        render: (created, r) => (
          <Tooltip placement="top" title={getLocalDate(created)}>
            {getLocalFromNow(created)}
          </Tooltip>
        ),
        filter: {
          type: "date"
          //filterOptions: { options: ["Low", "Medium", "High"] }
        }
        // sorter: true
      },

      {
        title: "Avg. Execution Time",
        dataIndex: "avg_execution_time",
        //width: 100,
        render: seconds => tcFieldHelper.avgExecTime(seconds),
        filter: {
          type: "numeric",
          filterOptions: { unit: "seconds", operator: "greater-than" }
        },
        sorter: true,
        className: "alignCenter"
      },

      {
        title: "Created By",
        dataIndex: "createdBy",
        filterName: "created_by",
        //width: 100,
        render: createdBy => {
          return createdBy ? (
            <Tooltip placement="left" title={createdBy.name}>
              <a style={{ color: "#fff" }}>
                <UserAvatar
                  size="28"
                  name={createdBy.name}
                  src={createdBy.avatar}
                />
              </a>
            </Tooltip>
          ) : (
            "NA"
          );
        },
        filter: {
          type: "user"
          //filterOptions: { options: ["Low", "Medium", "High"] }
        },
        className: "alignCenter"
      },

      {
        title: "Tags",
        dataIndex: "tags",
        //width: 100,
        render: (text, testCase) => (
          <TestCaseTags testCase={testCase} hideTitle={true} />
        ),
        filter: {
          type: "tag",
          filterOptions: { operator: "match-all" }
        }
        //filterType: "option"
      }
    ];
  },
  columnsOld: [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      filter: {
        type: "numeric"
      },
      sorter: true
      //filterType: "numeric"
      //fixed: "left",
      //width: 50
    },
    {
      title: "Title",
      dataIndex: "title",
      filter: {
        type: "text"
      },
      sorter: true,
      width: 200
      //fixed: "left",
    },
    {
      title: "Suite",
      dataIndex: "suite_title",
      filter: {
        type: "suite",
        filterOptions: { operator: "contains" }
      },
      render: (text, testCase) => (
        <span>
          <Tooltip
            placement="right"
            title={testCase.suite_path != null ? testCase.suite_path : ""}
          >
            <a style={{ textDecoration: "underline dashed", color: "inherit" }}>
              {text}
            </a>
          </Tooltip>
        </span>
      ),
      sorter: true
      //width: 100
    },
    {
      title: "Priority",
      dataIndex: "priority",
      //width: 100,
      render: text => <TestCasePriority priority={text} />,
      filter: {
        type: "priority",
        filterOptions: { options: ["Low", "Medium", "High"] }
      },
      sorter: true
      //filterType: "option"
    },
    {
      title: "Last Run Status",
      dataIndex: "last_run_status",
      //width: 100,
      render: status => <TestRunStatus status={status} />,
      filter: {
        type: "option",
        filterOptions: { options: ["Failed", "Passed", "Skipped"] }
      }
      //[{text: <TestRunStatus status="fail" />, value: "fail"}, {text: <TestRunStatus status={1} />, value: 1}, {text: <TestRunStatus status={2} />, value: 2}],
    },
    {
      title: "Last Run",
      dataIndex: "last_run_on",
      //width: 100,
      render: last_run_on => tcFieldHelper.lastRanOn(last_run_on),
      filter: {
        type: "date"
        //filterOptions: { options: ["Low", "Medium", "High"] }
      }
    },
    {
      title: "Runs",
      dataIndex: "run_count",
      filter: {
        type: "numeric"
      }
    },

    {
      title: "Created",
      dataIndex: "createdAt",
      filterName: "created_at",
      //width: 100,
      render: created => (
        <Tooltip placement="top" title={getLocalDate(created)}>
          {getLocalFromNow(created)}
        </Tooltip>
      ),
      filter: {
        type: "date"
        //filterOptions: { options: ["Low", "Medium", "High"] }
      }
      // sorter: true
    },

    {
      title: "Avg. Execution Time",
      dataIndex: "avg_execution_time",
      //width: 100,
      render: seconds => tcFieldHelper.avgExecTime(seconds),
      filter: {
        type: "numeric",
        filterOptions: { unit: "seconds" }
      },
      sorter: true
    },

    {
      title: "Created By",
      dataIndex: "createdBy",
      //width: 100,
      render: (createdBy, record) => {
        // console.log("CRREATE BY", createdBy);
        return createdBy ? (
          <Tooltip placement="left" title={createdBy.name}>
            <a style={{ color: "#fff" }}>
              <UserAvatar
                size="28"
                name={createdBy.name}
                src={createdBy.avatar}
              />
            </a>
          </Tooltip>
        ) : (
          "NA"
        );
      },
      filter: {
        type: "user"
        //filterOptions: { options: ["Low", "Medium", "High"] }
      }
    },

    {
      title: "Tags",
      dataIndex: "tags",
      //width: 100,
      render: (text, testCase) => (
        <TestCaseTags testCase={testCase} hideTitle={true} />
      ),
      filter: {
        type: "tag",
        filterOptions: {}
      }
      //filterType: "option"
    }
  ]
  /*
  getFilterType: (field) => {
    const fieldInfo = _.keyBy(this.columns, "dataIndex")[field];
    if(fieldInfo.filterType)
    {
      return fieldInfo.filterType
    }
    return false
  }*/
};
